<template>
  <div>
    <section :style="`background: url(${bg1}) bottom left no-repeat;`">
      <v-container fluid>
        <v-row>
          <!-- simule os resultados -->
          <v-col cols="12" offset-md="1" md="4" offset-lg="1" lg="4" offset-xlg="2" xlg="3">
            <TheFunnelSimulatorForm
              @calcular="handleCalcularFunil"
              :showErrorAlert="showErrorAlert"
              :errorAlertText="errorAlertText"
            />
          </v-col>

          <!-- funil -->
          <v-col cols="12" md="7" lg="7" xlg="8">
            <v-container>
              <v-row class="funnel-container">
                <v-col>
                  <TheFunnel
                    :leads="leadsLabel"
                    :oportunidades="oportunidadesLabel"
                    :demonstracoes="demonstracoesLabel"
                    :propostas="propostasLabel"
                    :vendas="vendasLabel"
                    :taxaPropostasPorVenda="taxaPropostasPorVenda"
                    :taxaDemosPorProposta="taxaDemosPorProposta"
                    :taxaLeadsPorOportunidade="taxaLeadsPorOportunidade"
                    :taxaOportunidadesPorDemo="taxaOportunidadesPorDemo"
                  />
                </v-col>
              </v-row>
              <v-row class="mt-5">
                <v-col>
                  <FunnelResults
                    :meta="meta"
                    :vendas="vendasLabel"
                    :conversao="parseFloat(conversao.toFixed(3).replace(/[.,]00$/, ''))"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <v-dialog v-model="showModalRd" max-width="700px" width="85%">
      <v-card>
        <FormRd @leadSent="handleLeadsSent" />
      </v-card>
    </v-dialog>

    <!-- "Principais Indicadores em Vendas" -->
    <section class="section2-bg pa-10" :style="`background-image: url(${bg2});`">
      <IndicadoresContainer />
    </section>

    <!-- Ofertas -->
    <section class="section3-bg pa-5">
      <OfertasContainer />
    </section>
  </div>
</template>

<script>
import TheFunnelSimulatorForm from '../components/TheFunnelSimulatorForm'
import TheFunnel from '../components/TheFunnel'
import FunnelResults from '../components/FunnelResults'
import IndicadoresContainer from '../components/IndicadoresContainer'
import FormRd from '../components/FormRd'
import OfertasContainer from '../components/OfertasContainer'
import bg1 from '../assets/bg01.svg'
import bg2 from '../assets/bg02.svg'

export default {
  components: {
    TheFunnelSimulatorForm,
    TheFunnel,
    FunnelResults,
    IndicadoresContainer,
    OfertasContainer,
    FormRd
  },
  data: function() {
    return {
      userDidFirstCalc: false,

      formFields: null,
      showModalRd: false,
      vendas: 0,
      propostas: 0,
      demonstracoes: 0,
      oportunidades: 0,
      leads: 0,
      meta: 0,
      conversao: 0,

      taxaPropostasPorVenda: 0,
      taxaDemosPorProposta: 0,
      taxaLeadsPorOportunidade: 0,
      taxaOportunidadesPorDemo: 0,

      showErrorAlert: false,
      errorAlertText: '',

      showAlertTimeoutFunction: null,
      bg1: bg1,
      bg2: bg2,

      lead: null
    }
  },
  mounted() {
    this.lead = localStorage.lead ? JSON.parse(localStorage.lead) : null
    if (!this.lead) {
      // this.$router.push({ path: `?unregistered` })
      dataLayer.push({'event': 'entra-sem-cadastro'});
    }
  },
  methods: {
    handleCalcularFunil(inputFields) {
      this.formFields = inputFields

      if (!this.checkFormValid(this.formFields)) {
        this.warnInvalidForm()
        return
      }

      if (!this.lead) {
        // this.$router.push({ path: '/', query: {register: false}})
        dataLayer.push({'event': 'calcula-sem-cadastro'});
        this.showModalRd = true
        return
      } else {
        dataLayer.push({'event': 'user-cadastrado-calcula'});
        this.calculaFunil(this.formFields)
      }
    },
    handleLeadsSent(lead) {
      //salva evento no tag manager
      dataLayer.push({'event': 'cadastro-rd'});
      
      this.showModalRd = false
      this.lead = lead
      this.lead.token_rdstation = null
      localStorage.lead = JSON.stringify(lead)
      this.calculaFunil(this.formFields)
    },
    calculaFunil(formFields) {
      this.userDidFirstCalc = true
      this.meta = formFields.inputValorMeta
      this.vendas = this.calculaVenda(
        formFields.inputValorMeta,
        formFields.inputTicketMedio
      )

      this.taxaPropostasPorVenda = 1 / formFields.propostasPorVenda
      this.propostas = this.calculaPorcentagem(
        this.vendas,
        this.taxaPropostasPorVenda
      )

      this.taxaDemosPorProposta = 1 / formFields.demosPorProposta
      this.demonstracoes = this.calculaPorcentagem(
        this.propostas,
        this.taxaDemosPorProposta
      )

      this.taxaOportunidadesPorDemo = 1 / formFields.oportunidadesPorDemo
      this.oportunidades = this.calculaPorcentagem(
        this.demonstracoes,
        this.taxaOportunidadesPorDemo
      )

      this.taxaLeadsPorOportunidade = 1 / formFields.leadsPorOportunidade
      this.leads = this.calculaPorcentagem(
        this.oportunidades,
        this.taxaLeadsPorOportunidade
      )

      this.conversao = (this.vendas * 100) / this.leads
    },

    calculaVenda(meta, ticketMedio) {
      const vendas = meta / ticketMedio
      if (vendas <= 1) {
        return 1
      }
      return Math.ceil(vendas)
    },
    calculaPorcentagem(valor, taxa) {
      return Math.ceil(valor / taxa)
    },
    roundToTwo(num) {
      if (typeof num !== 'number') {
        return
      }
      return +(Math.round(num + 'e+2') + 'e-2')
    },
    checkFormValid(formFields) {
      let valid = true
      for (let field in formFields) {
        if (Object.prototype.hasOwnProperty.call(formFields, field)) {
          if (!formFields[field] || formFields[field] <= 0) {
            valid = false
            return
          }
        }
      }
      return valid
    },
    warnInvalidForm() {
      clearTimeout(this.showAlertTimeoutFunction)
      this.showErrorAlert = true
      this.errorAlertText = 'Todos os campos devem ser preenchidos e positivos'

      this.showAlertTimeoutFunction = setTimeout(() => {
        this.showErrorAlert = false
      }, 4000)
    }
  },
  computed: {
    oportunidadesLabel() {
      return this.userDidFirstCalc ? this.oportunidades : '?'
    },
    demonstracoesLabel() {
      return this.userDidFirstCalc ? this.demonstracoes : '?'
    },
    propostasLabel() {
      return this.userDidFirstCalc ? this.propostas : '?'
    },
    vendasLabel() {
      return this.userDidFirstCalc ? this.vendas : '?'
    },
    leadsLabel() {
      return this.userDidFirstCalc ? this.leads : '?'
    }
  }
}
</script>

<style scoped>
.funnel-container {
  background-color: #fafafa;
}
.section2-bg {
  background-position: top left;
  background-repeat: no-repeat;
  background-color: #f8f8f8;
}
.section3-bg {
  background-color: white;
}
</style>